import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import axiosConfig from "../../Service/axiosConfig";
import { AccessDeny } from "./AccesssDeny";
import {
  requestGeolocation,
  checkGeolocationPermission,
  getGeolocationErrorMessage,
  GEOLOCATION_ERRORS,
} from "../../Utils/geolocation";

const LocationModalNavBar = ({
  setLocatioNavBarType,
  LocationNavBarType,
  setLocationAddress,
  Order,
  setOrders,
}) => {
  const [show, setShow] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [key, setKey] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  const [NoAccess, setNoAccess] = useState("");

  const HandleAccess = () => {
    setNoAccess("success");
    setShow(false);
  };

  const resolveStoreForLocation = async (lat, lng, address = "") => {
    const response = await axiosConfig.get(
      "/stores/stores/?page=1&page_size=50&is_suspended=false"
    );
    const stores = response?.data?.results || [];
    const store = stores.find((item) => item.is_online === "online") || stores[0];
    if (!store?.id) return false;

    localStorage.setItem("storeId", store.id);
    localStorage.setItem("opens_at", store.opens_at || "");
    localStorage.setItem("closes_at", store.closes_at || "");
    localStorage.setItem("slot_duration", store.slot_duration || "");
    localStorage.setItem("address", address || store.address || "");
    localStorage.setItem("latitude", lat);
    localStorage.setItem("longitude", lng);
    setOrders({ ...Order, stores: store.id });
    setLocationAddress(address || store.address || "");
    setShow(false);
    window.location.reload();
    return true;
  };

  const handlePlaceChanged = async () => {
    const [place] = inputRef.current.getPlaces();
    if (place) {
      console.log(place.formatted_address);
      console.log(place.geometry.location.lat());
      console.log(place.geometry.location.lng());
      try {
        const resolved = await resolveStoreForLocation(
          place.geometry.location.lat(),
          place.geometry.location.lng(),
          place.formatted_address
        );
        if (!resolved) {
          HandleAccess();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const GetKey = async () => {
    try {
      const responce = await axiosConfig.get(`/masters/googlemapkey/`);
      console.log(responce);
      if (responce.data?.results?.length > 0) {
        setKey(responce.data.results[0]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetKey();
  }, []);

  // Cross-browser geolocation handler using the shared utility.
  // Replaces the old buggy getCurrentPosition call. Now supports iOS Safari,
  // Android Chrome, etc. with proper permission pre-checks and user-friendly
  // error messages.
  const LocationData = async () => {
    setError(null);
    try {
      const permission = await checkGeolocationPermission();
      if (permission === "denied") {
        setError(getGeolocationErrorMessage(GEOLOCATION_ERRORS.PERMISSION_DENIED));
        return;
      }

      setLoading(true);
      const { latitude: lat, longitude: lng } = await requestGeolocation();
      setLatitude(lat);
      setLongitude(lng);

      const resolved = await resolveStoreForLocation(lat, lng);
      if (!resolved) {
        HandleAccess();
      }
    } catch (err) {
      if (err && err.code) {
        setError(err.message || getGeolocationErrorMessage(err.code));
      } else {
        console.log(err);
        setError("Something went wrong while detecting your location. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    setLocatioNavBarType("");
    console.log("ffgg");
  };

  const handleShow = () => setShow(true);

  const GetData = () => {
    if (LocationNavBarType === "success") {
      setShow(true);
      console.log("sss");
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [LocationNavBarType]);

  return (
    <>
      <div>
        <Modal className="template-temp2" show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title className="template-temp2 change-location-title">
              Change Location
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex align-items-center justify-content-between">
              <button
                type="button"
                className="btn--link"
                onClick={LocationData}
                disabled={loading}
              >
                {loading ? "Detecting..." : "Detect My Location"}
              </button>
              <div className="oval-container">
                <div className="oval">
                  <span className="separator-text">
                    <div className="or">OR</div>
                  </span>
                </div>
              </div>
              <div>
                <LoadScript googleMapsApiKey={key?.key} libraries={["places"]}>
                  <StandaloneSearchBox
                    onLoad={(ref) => (inputRef.current = ref)}
                    onPlacesChanged={handlePlaceChanged}
                  >
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Location"
                    />
                  </StandaloneSearchBox>
                </LoadScript>
              </div>
            </div>
            {error && (
              <div className="Loginerror mt-2 text-center" role="alert">
                {error}
              </div>
            )}
          </Modal.Body>
        </Modal>
        {NoAccess === "success" && (
          <AccessDeny
            NoAccess={NoAccess}
            setNoAccess={setNoAccess}
            NavBarType={setLocatioNavBarType}
            setLocationAddress={setLocationAddress}
          />
        )}
      </div>
    </>
  );
};
export { LocationModalNavBar };
